import React from 'react'

const FasterNbnBoosterBanner = () => {
    return (
        <div className='faster-nbn-booster-banner module py-3'>
            <div className='row d-lg-flex d-none'>
                <div className='col-7 text-center'>
                    <h1 className='m-0 mb-3'>
                        Is your internet lagging? <br />
                        Try Exetel's My Speed Boost™ today
                    </h1>
                    <p className='bold'>
                        With the push of a button you can temporaily boost your Exetel nbn® speed with 5 FREE Speed Upgrade Days each and every month.
                    </p>
                    <div className='speed-boost-bg mt-3'>
                        <a className='' href='https://www.exetel.com.au/speed-boost' target='_blank'>
                            <img src='/images/find-out-more.svg' alt='speedBoost-button' />
                        </a>
                    </div>
                </div>
                <div className='col-lg-5' />
            </div>
            <div className='d-lg-none d-block banner-mobile text-left'>
                <h1 className='m-0 mt-5 w-50'>
                    Is your <br />internet lagging? <br />
                    Try Exetel's My Speed Boost™ today
                </h1>
                <div className='speed-boost-bg w-50 mt-3'>
                    <a className='' href='https://www.exetel.com.au/speed-boost' target='_blank'>
                        <img src='/images/find-out-more.svg' alt='speedBoost-button' />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default FasterNbnBoosterBanner



// WEBPACK FOOTER //
// ./resources/js/components/FasterNbnBoosterBanner.js